import api from './api';

export const fetchMe = () => api.get('/me').then(r => r.data);

// Admin
export const adminListOrgs = () => api.get('/admin/organizations').then(r => r.data);
export const adminCreateOrg = (payload) => api.post('/admin/organizations', payload).then(r => r.data);
export const adminUpdateOrgStatus = (orgId, statusValue) =>
  api.patch(`/admin/organizations/${orgId}`, null, { params: { status_value: statusValue } }).then(r => r.data);

export const adminListUsers = () => api.get('/admin/users').then(r => r.data);
export const adminInviteUser = (payload) => api.post('/admin/users/invite', payload).then(r => r.data);
export const adminUpdateUser = (userId, payload) => api.patch(`/admin/users/${userId}`, payload).then(r => r.data);

export const adminActivity = () => api.get('/admin/activity').then(r => r.data);

// Pilot
export const submitPilotRequest = (payload) => api.post('/pilot-requests', payload).then(r => r.data);
export const adminListPilotRequests = () => api.get('/pilot-requests').then(r => r.data);
export const adminUpdatePilotRequest = (id, payload) => api.patch(`/pilot-requests/${id}`, payload).then(r => r.data);
